var map = {
	"./bs_web_frame_base02_.png": 548019,
	"./bs_web_frame_base02_blk.png": 469622,
	"./bs_web_frame_base02_blu.png": 363800,
	"./bs_web_frame_base02_cho 2.png": 393573,
	"./bs_web_frame_base02_cho.png": 543783,
	"./bs_web_frame_base02_cml.png": 931099,
	"./bs_web_frame_base02_crk.png": 25745,
	"./bs_web_frame_base02_dor.png": 254168,
	"./bs_web_frame_base02_gld.png": 447196,
	"./bs_web_frame_base02_grn.png": 807048,
	"./bs_web_frame_base02_gry.png": 637591,
	"./bs_web_frame_base02_lmn.png": 511225,
	"./bs_web_frame_base02_mgn.png": 480325,
	"./bs_web_frame_base02_nvy.png": 347270,
	"./bs_web_frame_base02_orn.png": 285152,
	"./bs_web_frame_base02_pnk.png": 945306,
	"./bs_web_frame_base02_ppl.png": 21559,
	"./bs_web_frame_base02_red.png": 860934,
	"./bs_web_frame_base02_sax.png": 157259,
	"./bs_web_frame_base02_sil.png": 205287,
	"./bs_web_frame_base02_wht.png": 447568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343798;